import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { getByDocCreator } from '../helpers/getByDocCreator';

// styles
import styles from './PdpRespTitle.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

const smartlingClassName = 'sl-override-context';

export function PdpRespTitleComponent(props) {
    const { item, wrapperClass, artTitleClass } = props;
    let artCreator = null;
    let artCreationDate = null;
    let itemTitle = get(item, 'title');

    const wrapperClasses = classNames(styles.wrapper, {
        [wrapperClass]: wrapperClass,
    });

    if (item.isArt) {
        itemTitle = (
            <span
                className={classNames(styles.artTitle, smartlingClassName, {
                    [artTitleClass]: artTitleClass,
                })}
                data-tn="pdp-item-title"
            >
                {itemTitle}
            </span>
        );

        // artCreationDate
        const creationDate = get(item, 'classification.creationDate');
        if (creationDate) {
            artCreationDate = <p data-tn="pdp-item-creation-date">{creationDate}</p>;
        }

        // artCreator
        artCreator = getByDocCreator(item?.creators);
    }

    return (
        <h1 className={wrapperClasses} data-tn="pdp-resp-title">
            {artCreator}
            <div className={classNames(styles.title, smartlingClassName)} data-tn="pdp-main-title">
                {itemTitle}
                {artCreationDate}
            </div>
        </h1>
    );
}

PdpRespTitleComponent.propTypes = {
    artTitleClass: PropTypes.string,
    wrapperClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpRespTitle = createFragmentContainer(PdpRespTitleComponent, {
    item: graphql`
        fragment PdpRespTitle_item on Item {
            title
            isArt
            vertical
            creators {
                attribution
                creator {
                    name
                    displayName
                }
            }
            classification {
                creationDate
            }
        }
    `,
});
